import { gql, useMutation, useQuery } from "@apollo/client";
import { WBTypography } from "@apptractive/design-system-web";
import { getNextOnboardingStep } from "@apptractive/stm-shared";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Option } from "../../API";
import { AustraliaMap } from "../../components/AustraliaMap";
import { PageContainer } from "../../components/PageContainer";
import { SelectOptionsForm } from "../../components/SelectOptionsForm";
import { CSGetSub as GET_SUB } from "../../customGraphql/queries";
import { updateUser as UPDATE_USER } from "../../graphql/mutations";
import { getUser as GET_USER } from "../../graphql/queries";
import { getOnboardingPath } from "../../helpers/onboarding";

const OnboardingLocations = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: subData } = useQuery(gql(GET_SUB));
  const { data: userData } = useQuery(gql(GET_USER), {
    variables: {
      id: subData?.sub,
    },
    skip: !subData?.sub,
  });

  const [updateUser, { loading: updateLoading }] = useMutation(
    gql(UPDATE_USER)
  );

  const user = useMemo(() => userData?.getUser || {}, [userData]);

  const onSetOptions = async (locations: Option[]) => {
    try {
      const updateData = await updateUser({
        variables: {
          input: {
            id: subData?.sub,
            locations: locations.map((option) => option.value),
            onboardingStatus: getNextOnboardingStep(user),
          },
        },
      });

      const updatedUser = updateData?.data?.updateUser;
      navigate(getOnboardingPath(updatedUser), { replace: true });
    } catch (err) {
      console.log("err: ", err);
    }
  };

  return (
    <PageContainer
      sx={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <WBTypography variant="h1">
        {t("selectLocationsTitle", { ns: "onboarding" })}
      </WBTypography>
      {user?.country !== "AU" && (
        <SelectOptionsForm
          selectedOptions={[]}
          category={`locations-${user?.country}`}
          onSubmit={onSetOptions}
        />
      )}

      {user?.country === "AU" && (
        <AustraliaMap
          selectedOptions={[]}
          isLoading={updateLoading}
          onSubmit={onSetOptions}
        />
      )}
    </PageContainer>
  );
};

export default OnboardingLocations;
